import { Box, Typography } from "@mui/material";

import { replaceTextTokens } from "../utils/replaceTextTokens";
import { UW_NOTE_TOKENS } from "../common/uwNoteTokens";

interface UWReviewNotesProps {
  notes?: string[];
  fontSize?: number;
}

export const UWReviewNotes = ({ notes, fontSize }: UWReviewNotesProps) => (
  <Box component="ul" mt={1} mb={3}>
    {notes?.map((note) => (
      <Typography
        key={note}
        color="secondary"
        component="li"
        mt={1}
        fontSize={fontSize}>
        {replaceTextTokens(note, UW_NOTE_TOKENS)}
      </Typography>
    )) || []}
  </Box>
);
